import * as React from 'react';
import { createContainer } from '@workday/canvas-kit-react/common';
import { usePopupModel } from './hooks';
import { PopupCard } from './PopupCard';
import { PopupTarget } from './PopupTarget';
import { PopupPopper } from './PopupPopper';
import { PopupHeading } from './PopupHeading';
import { PopupCloseIcon } from './PopupCloseIcon';
import { PopupCloseButton } from './PopupCloseButton';
import { PopupBody } from './PopupBody';
export var Popup = createContainer()({
    displayName: 'Popup',
    modelHook: usePopupModel,
    subComponents: {
        Heading: PopupHeading,
        Body: PopupBody,
        Card: PopupCard,
        CloseIcon: PopupCloseIcon,
        Target: PopupTarget,
        Popper: PopupPopper,
        CloseButton: PopupCloseButton,
    },
})(function (_a) {
    var children = _a.children;
    return React.createElement(React.Fragment, null, children);
});
